var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-member.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "loyalty/templates/loyalty-member.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("homepageUrl")) {
var t_4 = t_1.homepageUrl;
} else {
cb(new Error("cannot import 'homepageUrl'")); return;
}
context.setVariable("homepageUrl", t_4);
output += "<div class=\"o-row\">\n    <div class=\"g-loyalty-form__member\">\n\n        <p class=\"u-global-p\" data-qa-is-loyalty-member>\n            ";
output += runtime.suppressValue((lineno = 7, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_member-message"])), env.opts.autoescape);
output += "\n        </p>\n        \n        <p class=\"u-global-p\">\n            ";
output += runtime.suppressValue((lineno = 11, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_member-shopping-message"])), env.opts.autoescape);
output += " <a class=\"u-link--underlined\" href=\"";
output += runtime.suppressValue((lineno = 11, colno = 99, runtime.callWrap(t_4, "homepageUrl", context, [])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue((lineno = 11, colno = 106, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_member-shopping-message-link"])), env.opts.autoescape);
output += "</a>\n        </p>\n\n        <p class=\"u-text-details\">\n            ";
output += runtime.suppressValue((lineno = 15, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_member-questions-message-1"])), env.opts.autoescape);
output += " <a href=\"tel:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"customerService")),"phone"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"customerService")),"phone"), env.opts.autoescape);
output += "</a> ";
output += runtime.suppressValue((lineno = 15, colno = 132, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_member-questions-message-2"])), env.opts.autoescape);
output += " <a href=\"mailto:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"customerService")),"email"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"customerService")),"email"), env.opts.autoescape);
output += "</a>\n        </p>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-member.j2"] , dependencies)